/* eslint-disable no-param-reassign */
import { createStore } from "vuex";
import storeAb from "../../vue-product-details-print-ab/store/store";

import artworkModule from "./artwork-module";
import checkoutModule from "./checkout-module";
import creationModule from "./creation-module";
import deliveryModule from "./delivery-module";
import surfaceModule from "./surface-module";
import appModule from "./app-module";
import productModule from "./product-module";
import presetModule from "./preset-module";

const initialState = {
  config: {}
};

const store = createStore({
  state() {
    return { ...initialState };
  },
  getters: {
    config: state => state.config,
    experiments: (_, getters) => getters.config?.experiments || {}
  },
  mutations: {
    setConfig(state, value) {
      state.config = value;
    }
  },
  actions: {},
  modules: {
    artwork_front: artworkModule,
    artwork_back: artworkModule,
    surface_front: surfaceModule,
    surface_back: surfaceModule,
    checkout: checkoutModule,
    creation: creationModule,
    delivery: deliveryModule,
    product: productModule,
    preset_front: presetModule,
    preset_back: presetModule,
    app: appModule
  }
});

window.jiffy ||= {};
window.jiffy.madeStore = document.querySelector(".js-ab-made-monetization-enabled")
  ? storeAb
  : store;
export default document.querySelector(".js-ab-made-monetization-enabled") ? storeAb : store;
